import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-short-videos',
  templateUrl: './short-videos.component.html',
  styleUrls: ['./short-videos.component.scss']
})
export class ShortVideosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
